module.exports = __webpack_public_path__ + "img/territorial.3220bc6d.png";